import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../api';
import api from '../../api/endpoints';

function* getCommissionRules({ payload: { signal } }) {
  try {
    const { data } = yield call(fetch, { api: api.commissionRules.list, signal });
    yield put(actions.getCommissionRulesDone(data));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getCommissionRulesFailed,
      endpoint: api.commissionRules.list.url
    });
  }
}

function* createCommissionRule({ payload: { values, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.commissionRules.create, data: values });
    onSuccess && onSuccess();
    yield put(actions.createCommissionRuleDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.createCommissionRuleFailed,
      handledErrors,
      endpoint: api.commissionRules.create.url
    });
  }
}

function* updateCommissionRule({ payload: { id, values, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.commissionRules.update, id, data: values });
    onSuccess && onSuccess();
    yield put(actions.updateCommissionRuleDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.updateCommissionRuleFailed,
      handledErrors,
      endpoint: api.commissionRules.update.url
    });
  }
}

function* deleteCommissionRule({ payload: { id, onSuccess } }) {
  try {
    yield call(fetch, { api: api.commissionRules.remove, id });
    onSuccess && onSuccess();
    yield put(actions.deleteCommissionRuleDone({ id }));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.deleteCommissionRuleFailed,
      endpoint: api.commissionRules.remove.url
    });
  }
}

function* reorderCommissionRule({ payload: { id, order } }) {
  try {
    yield call(fetch, { api: api.commissionRules.reorder, id, data: { order } });
    // The dragged rule's new position can shift every other rule's own `order` too (they all
    // share one interleaved priority list) - refetching is the only way to get a consistent set.
    const { data } = yield call(fetch, { api: api.commissionRules.list });
    yield put(actions.reorderCommissionRuleDone(data));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.reorderCommissionRuleFailed,
      endpoint: api.commissionRules.reorder.url
    });
  }
}

export const getCommissionRulesSaga = takeEvery(types.GET_COMMISSION_RULES_REQUEST, getCommissionRules);
export const createCommissionRuleSaga = takeEvery(types.CREATE_COMMISSION_RULE_REQUEST, createCommissionRule);
export const updateCommissionRuleSaga = takeEvery(types.UPDATE_COMMISSION_RULE_REQUEST, updateCommissionRule);
export const deleteCommissionRuleSaga = takeEvery(types.DELETE_COMMISSION_RULE_REQUEST, deleteCommissionRule);
export const reorderCommissionRuleSaga = takeEvery(types.REORDER_COMMISSION_RULE_REQUEST, reorderCommissionRule);
